import { render, staticRenderFns } from "./MenuItemOptionsSelector.vue?vue&type=template&id=72accf3b&scoped=true&"
import script from "./MenuItemOptionsSelector.vue?vue&type=script&lang=js&"
export * from "./MenuItemOptionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemOptionsSelector.vue?vue&type=style&index=0&id=72accf3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72accf3b",
  null
  
)

export default component.exports